<div class="package-builder-responsive p-g">
  <div class="p-g-12" *ngIf="mode == 'add'">
    <app-addpackage-builder></app-addpackage-builder>
  </div>
  <p-toast position="top-right"></p-toast>
  <div class="p-g-12" *ngIf="mode == 'edit'">
    <p-toolbar>
      <div class="p-toolbar-group-left p-toolbar-tecfolk-fix">
          <button routerLink="/package-Builders" pButton type="button" icon="pi pi-arrow-left">&nbsp;&nbsp;{{setLabel("goBackBtnLabel")}}</button>
      </div>
  </p-toolbar>
    <p-tabView [activeIndex]="index">
      <p-tabPanel [header]='setLabel("detailsHeaderLabel")'>
        <div class="card card-w-title">
          <div class="p-g-12">
            <form #memberSignUpForm="ngForm">
              <div class="p-g-12">
                <!-- <button id="loginbtn" [disabled]="loading" (click)="reverse()"
                          class="p-button p-widget p-state-default p-corner-all">
                          <span class="p-button-text p-c">Back</span>
                          <span *ngIf="loading" class="p-button-icon-left p-c fa fa-spinner fa-spin" style="font-size:24px"></span>
                        </button>&nbsp;&nbsp; -->


              </div>
              <div class="p-g-12 p-md-6" style="text-align: left">
                <h3 class="main-heading first">{{setLabel("packageBuilderDetailsLabel")}}</h3>
                <div class="p-g p-fluid">
                  <div class="p-g-12">
                    <h3 class="first">{{setLabel("packageNameLabel")}}</h3>
                    <div class="p-inputgroup">
                      <span class="p-inputgroup-addon"><i class="fa fa-user" aria-hidden="true"></i></span>
                      <input autocomplete="off" pattern="[A-Za-z ]+"
                        [ngClass]="packageName.invalid && (packageName.dirty || packageName.touched) ? 'errorInput' : '' "
                        type="text" pInputText [placeholder]='setLabel("name*PlaceholderLabel")' #packageName="ngModel"
                        name="name" required maxlength="100" [(ngModel)]="package.packageName">
                    </div>
                    <div *ngIf="packageName.invalid && (packageName.dirty || packageName.touched)">
                      <div *ngIf="packageName.errors.required" class="errorShow">
                        {{setLabel("packageNameErrorLabel")}}
                      </div>
                      <div *ngIf="packageName.errors.pattern" class="errorShow">
                        {{setLabel("packageNameCharactersErrorLabel")}}
                      </div>
                    </div>
                  </div>
                  <!-- <h3 class="first">Joining Date</h3>
                          <div class="p-g-12">
                            <p-calendar [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true"
                              [(ngModel)]="member.joiningDate" placeholder="Joining Date" name="joinDate" [inline]="false"
                              dateFormat="dd/mm/yy" [showIcon]="true">
                            </p-calendar>
                          </div>
                          <h3 class="first">Date Of Birth</h3>
                          <div class="p-g-12">
                            <p-calendar [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true"
                              [(ngModel)]="member.dateOfBirth" placeholder="Date Of Birth" name="dateOfBirth" [inline]="false"
                              dateFormat="dd/mm/yy" [showIcon]="true">
                            </p-calendar>
                          </div> -->
                  <div class="p-g-12">
                    <div class="p-g">
                      <h3 class="first">{{setLabel("packageTypeLabel")}}</h3>
                      <div class="p-g-12">
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                          <input type="text" required #packageType="ngModel" pattern="[0-9]+" autocomplete="off"
                            [disabled]="true"
                            [ngClass]="packageType.invalid && (packageType.dirty || packageType.touched) ? 'errorInput' : '' "
                            [placeholder]='setLabel("packageType*PlaceholderLabel")' pInputText name="packageType"
                            [(ngModel)]="package.packageType">
                        </div>
                        <div *ngIf="packageType.invalid && (packageType.dirty || packageType.touched)">
                          <div *ngIf="packageType.errors.required" class="errorShow">
                            {{setLabel("packageTypeErrorLabel")}}
                          </div>
                          <div *ngIf="packageType.errors.pattern" class="errorShow">
                            {{setLabel("packageNumbersErrorLabel")}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="p-g-12">
                    <div class="p-g">
                      <!-- <h3 class="first">Logo</h3>
                              <div class="p-g-12">
                                <div class="p-inputgroup">
                                  <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                                  <input type="text" required #logo="ngModel" pattern="[0-9]+" autocomplete="off"
                                    [ngClass]="logo.invalid && (logo.dirty || logo.touched) ? 'errorInput' : '' " placeholder="logo *"
                                    pInputText name="logo" [(ngModel)]="package.logo">
                                </div>
                                <div *ngIf="logo.invalid && (logo.dirty || logo.touched)">
                                  <div *ngIf="logo.errors.required" class="errorShow">
                                    logo is required.
                                  </div>
                                  <div *ngIf="logo.errors.pattern" class="errorShow">
                                     Numbers are allowed.
                                  </div>
                                </div>
                              </div> -->
                      <div class="p-g-12">
                        <div class="p-g">
                          <h3>{{setLabel("logoLabel")}}</h3>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <p-listbox [options]="packagesLogo" [style]="{'width': '110%'}" required
                            [(ngModel)]="selectedLogo" [ngModelOptions]="{standalone: true}"
                            [listStyle]="{'max-height':'250px'}">
                            <ng-template let-logo pTemplate="item">
                              <div class="p-helper-clearfix">
                                <img src="assets/demo/gymLogo/{{logo.value}}.png"
                                  style="display:inline-block;margin:5px 0 0 5px" width="48">
                                <span style="float:right;margin:20px 10px 0 20px">{{logo.label}}</span>
                              </div>
                            </ng-template>
                            <p-footer>
                              {{setLabel("selectedLabel")}} {{selectedLogo ||'none'}}
                            </p-footer>
                          </p-listbox>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="p-g-12">
                    <div class="p-g">
                      <h3 class="first">{{setLabel("packageColorLabel")}}</h3>
                      <div class="p-g-12">
                        <div class="package-color p-inputgroup">
                          <!-- <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span> -->
                          <!-- <input type="text" required #color="ngModel" pattern="[0-9]+" autocomplete="off"
                                    [ngClass]="color.invalid && (color.dirty || color.touched) ? 'errorInput' : '' "
                                    placeholder="color *" pInputText name="logo" [(ngModel)]="package.color"> -->
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <p-colorPicker name="color" required #color="ngModel" [inline]="true"
                            [(ngModel)]="package.color">
                          </p-colorPicker>&nbsp;&nbsp;&nbsp;
                          <p style="margin-top:.5em">{{setLabel("packageColor:Label")}} <span>{{package.color}}</span>
                          </p>
                        </div>
                        <div *ngIf="color.invalid && (color.dirty || color.touched)">
                          <div *ngIf="color.errors.required" class="errorShow">
                            {{setLabel("packageColorErrorLabel")}}
                          </div>
                          <div *ngIf="color.errors.pattern" class="errorShow">
                            {{setLabel("packageNumbersLabel")}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="p-g-12">
                    <div class="p-g">
                      <h3 class="first">{{setLabel("descriptionLabel")}}</h3>
                      <div class="p-g-12">
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                          <textarea type="text" #description="ngModel" style="width: 100%;" autocomplete="off"
                            [placeholder]='setLabel("description*PlaceholderLabel")' pInputText name="description"
                            [(ngModel)]="package.description"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="p-g-12 p-md-6" style="text-align: left">
                <br>
                <br>
                <br>
                <div class="p-g p-fluid">
                  <div class="p-g-12">
                    <h3 class="first">{{setLabel("sequenceNoLabel")}}</h3> <span
                      style="color: red;">*</span>&nbsp;&nbsp;
                    <div class="p-inputgroup">
                      <span class="p-inputgroup-addon"><i class="fa fa-user" aria-hidden="true"></i></span>
                      <input autocomplete="off" pattern="[0-9]+"
                        [ngClass]="sn.invalid && (sn.dirty || sn.touched) ? 'errorInput' : '' " type="number" pInputText
                        [placeholder]='setLabel("sequenceNo*PlaceholderLabel")' #sn="ngModel" name="sn" required
                        [(ngModel)]="package.sn">
                    </div>
                    <div *ngIf="sn.invalid && (sn.dirty || sn.touched)">
                      <div *ngIf="sn.errors.required" class="errorShow">
                        {{setLabel("serialErrorLabel")}}
                      </div>
                      <div *ngIf="sn.errors.pattern" class="errorShow">
                        {{setLabel("serialNumberErrorLabel")}}
                      </div>
                    </div>
                    <br>
                  </div>
                  <div class="p-g-12">
                    <h3 class="first">{{setLabel("noOfMembersLabel")}}</h3>
                    <div class="p-inputgroup">
                      <span class="p-inputgroup-addon"><i class="fa fa-user" aria-hidden="true"></i></span>
                      <input autocomplete="off" [disabled]="isMonthWisePackage" pattern="[0-9]+"
                        [ngClass]="noOfMembers.invalid && (noOfMembers.dirty || noOfMembers.touched) ? 'errorInput' : '' "
                        type="number" pInputText [placeholder]='setLabel("noOfMembers*PlaceholderLabel")'
                        #noOfMembers="ngModel" name="noOfMembers" required [(ngModel)]="package.noOfMembers">
                    </div>
                    <div *ngIf="noOfMembers.invalid && (noOfMembers.dirty || noOfMembers.touched)">
                      <div *ngIf="noOfMembers.errors.required" class="errorShow">
                        {{setLabel("enterMembersErrorLabel")}}
                      </div>
                      <div *ngIf="noOfMembers.errors.pattern" class="errorShow">
                        {{setLabel("membersContainErrorLabel")}}
                      </div>
                    </div>
                    <br>
                    <div class="p-inputgroup" *ngIf="isPersonWisePackage">
                      <span class="p-inputgroup-addon"><i class="fa fa-check-square-o" aria-hidden="true"></i></span>
                      <p-checkbox name="isGreaterthanNoOfMembers" [(ngModel)]="package.isGreaterthanNoOfMembers"
                        binary="true" inputId="binary"></p-checkbox> &nbsp; {{setLabel("isMoreThanLabel")}}
                    </div>
                  </div>


                  <div class="p-g-12">
                    <div class="p-g">
                      <h3 class="first">{{setLabel("packageFeeLabel")}}</h3>
                      <div class="p-g-12">
                        <div class="p-inputgroup" *ngIf="isMonthWisePackage && mode === 'add'">
                          <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                          <p-dropdown [options]="packageFeeTypes" name="packageFeeType" [style]="{'width':'100%'}"
                            required [(ngModel)]="package.packageFeeType">
                          </p-dropdown>
                        </div>
                        <div class="p-inputgroup" *ngIf="!isMonthWisePackage ">
                          <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                          <p-dropdown [options]="packageFeePersonWiseTypes" name="packageFeeType"
                            [style]="{'width':'100%'}" required [(ngModel)]="package.packageFeeType">
                          </p-dropdown>
                        </div>
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                          <input type="number" pattern="[0-9]+" autocomplete="off"
                            [ngClass]="packageFee.invalid && (packageFee.dirty || packageFee.touched) ? 'errorInput' : '' "
                            required #packageFee="ngModel" [placeholder]='setLabel("monthlyFeePKR*PlaceholderLabel")'
                            pInputText name="packageFee" [(ngModel)]="package.packageFee">
                        </div>
                        <div *ngIf="packageFee.invalid && (packageFee.dirty || packageFee.touched)">
                          <div *ngIf="packageFee.errors.required" class="errorShow">
                            {{setLabel("feeCorrectlyErrorLabel")}}
                          </div>
                          <div *ngIf="packageFee.errors.pattern" class="errorShow">
                            {{setLabel("feenumbersErrorLabel")}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="p-g-12">
                    <div class="p-g">
                      <h3 class="first">{{setLabel("registrationFeeLabel")}}</h3>
                      <div class="p-g-12">
                        <div *ngIf="mode === 'add'" class="p-inputgroup">
                          <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                          <p-dropdown [options]="packageRegFeePersonWiseTypes" name="packageRegFeePersonWiseTypes"
                            [style]="{'width':'100%'}" required [(ngModel)]="package.packageRegFeeType">
                          </p-dropdown>
                        </div>
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                          <input type="number" required #registerationFee="ngModel" pattern="[0-9]+" autocomplete="off"
                            [ngClass]="registerationFee.invalid && (registerationFee.dirty || registerationFee.touched) ? 'errorInput' : '' "
                            [placeholder]='setLabel("registrationFeePKR*PlaceholderLabel")' pInputText
                            name="registerNumber" [(ngModel)]="package.registerationFee">
                        </div>
                        <div *ngIf="registerationFee.invalid && (registerationFee.dirty || registerationFee.touched)">
                          <div *ngIf="registerationFee.errors.required" class="errorShow">
                            {{setLabel("registerationFeeErrorLabel")}}
                          </div>
                          <div *ngIf="registerationFee.errors.pattern" class="errorShow">
                            {{setLabel("feeContainNumbersErrorLabel")}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

  <div class="p-g-12">
    <div class="p-g">
      <h3 class="first">Package Duration </h3>
      <div class="p-g-12">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon"><i class="fa fa-hourglass-start" aria-hidden="true"></i></span>
          <p-dropdown [options]="packageDurationTypes" name="packageDurationType" [style]="{'width':'100%'}" required
            [(ngModel)]="packageDurationType">
          </p-dropdown>
        </div>
      </div>
    </div>
  </div>
<div class="p-g-12" *ngIf="packageDurationType == 'months' ">
  <div class="p-g">
    <h3 class="first">{{setLabel("noOfMonthLabel")}}</h3>
    <div class="p-g-12">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-hourglass-start" aria-hidden="true"></i></span>
        <input type="number" required #noOfMonths="ngModel" pattern="[0-9]+" min="1" autocomplete="off"
          [ngClass]="noOfMonths.invalid && (noOfMonths.dirty || noOfMonths.touched) ? 'errorInput' : '' "
          [placeholder]='setLabel("noOfMonth(s)*PlaceholderLabel")' pInputText name="noOfMonths"
          [(ngModel)]="package.noOfMonths">
      </div>
      <div *ngIf="noOfMonths.invalid && (noOfMonths.dirty || noOfMonths.touched)">
        <div *ngIf="noOfMonths.errors.required" class="errorShow">
          {{setLabel("noOfMonthRequiredErrorLabel")}}
        </div>
        <div *ngIf="noOfMonths.errors.pattern" class="errorShow">
          {{setLabel("numbersAllowedErrorLabel")}}
        </div>
        <div *ngIf="noOfMonths.errors.min" class="errorShow">
          Value cannot be 0
        </div>
      </div>
    </div>
  </div>
</div>
<div class="p-g-12" *ngIf="packageDurationType === 'weeks' ">
  <div class="p-g">
    <h3 class="first">No Of Weeks</h3>
    <div class="p-g-12">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-hourglass-start" aria-hidden="true"></i></span>
        <input type="number" required #noOfWeeks="ngModel" pattern="[0-9]+" min="1" autocomplete="off"
          [ngClass]="noOfWeeks.invalid && (noOfWeeks.dirty || noOfWeeks.touched) ? 'errorInput' : '' "
          placeholder='No of weeks' pInputText name="noOfWeeks" [(ngModel)]="package.noOfWeeks">
      </div>
      <div *ngIf="noOfWeeks.invalid && (noOfWeeks.dirty || noOfWeeks.touched)">
        <div *ngIf="noOfWeeks.errors.required" class="errorShow">
          No of Weeks are required
        </div>
        <div *ngIf="noOfWeeks.errors.pattern" class="errorShow">
          No of Weeks error
        </div>
        <div *ngIf="noOfWeeks.errors.min" class="errorShow">
          Value cannot be 0
        </div>
      </div>
    </div>
  </div>
</div>
<div class="p-g-12" *ngIf="packageDurationType === 'days' ">
  <div class="p-g">
    <h3 class="first">No Of Days</h3>
    <div class="p-g-12">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-hourglass-start" aria-hidden="true"></i></span>
        <input type="number" required #noOfDays="ngModel" pattern="[0-9]+" min="1" autocomplete="off"
          [ngClass]="noOfDays.invalid && (noOfDays.dirty || noOfDays.touched) ? 'errorInput' : '' "
          placeholder='No of Days' pInputText name="noOfDays" [(ngModel)]="package.noOfDays">
      </div>
      <div *ngIf="noOfDays.invalid && (noOfDays.dirty || noOfDays.touched)">
        <div *ngIf="noOfDays.errors.required" class="errorShow">
          No of Days are required
        </div>
        <div *ngIf="noOfDays.errors.pattern" class="errorShow">
          No of Days error
        </div>
        <div *ngIf="noOfDays.errors.min" class="errorShow">
          Value cannot be 0
        </div>
      </div>
    </div>
  </div>
</div>
                  <!-- <div class="p-g-12">
                    <div class="p-g">
                      <h3 class="first">{{setLabel("noOfMonthLabel")}}</h3>
                      <div class="p-g-12">
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon"><i class="fa fa-money" aria-hidden="true"></i></span>
                          <input type="number" required #noOfMonths="ngModel" pattern="[0-9]+" autocomplete="off"
                            [ngClass]="noOfMonths.invalid && (noOfMonths.dirty || noOfMonths.touched) ? 'errorInput' : '' "
                            [placeholder]='setLabel("no.OfMonth(s)*PlaceholderLabel")' pInputText name="noOfMonths"
                            [(ngModel)]="package.noOfMonths">
                        </div>
                        <div *ngIf="noOfMonths.invalid && (noOfMonths.dirty || noOfMonths.touched)">
                          <div *ngIf="noOfMonths.errors.required" class="errorShow">
                            {{setLabel("enterMonth(s)ErrorLabel")}}
                          </div>
                          <div *ngIf="noOfMonths.errors.pattern" class="errorShow">
                            {{setLabel("monthContainNumbersErrorLabel")}}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> -->
                  <div class="p-g-12">
                    <div class="p-g">
                      <h3 class="first">{{setLabel("ageGroupLabel")}}&nbsp;</h3>
                      <div class="p-g-12">
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon">{{setLabel("fromLabel")}}</span>
                          <input type="number" #ageFrom="ngModel" pattern="[0-9]+" autocomplete="off"
                            placeholder='Age From' pInputText name="ageFrom"
                            [(ngModel)]="package.ageGroupFrom">
                        </div>
                      </div>
                      <div class="p-g-12">
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon">{{setLabel("toLabel")}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                          <input type="number" #ageTo="ngModel" pattern="[0-9]+" autocomplete="off"
                            [ngClass]="ageTo.invalid && (ageTo.dirty || ageTo.touched) ? 'errorInput' : ''"
                            placeholder='Age To' pInputText name="ageTo"
                            [(ngModel)]="package.ageGroupTo">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="p-g-12">
                    <div class="p-g">
                      <h3 class="first">{{setLabel("feecollectionSettingsLabel")}}</h3>
                      <div class="p-g-12">
                        <div class="p-inputgroup">
                          <label class="checkboxCustomStyle" [ngClass]="{'selected': groupFeePayByOnePerson}" for="groupFeePayByOnePerson" (click)="groupFeePayByOnePerson = !groupFeePayByOnePerson">
                            <span>{{setLabel("onePersoncanpayfeeofwholepackageLabel")}}</span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="p-g-12" *ngIf="!isCompanyWisePackage">
                    <div class="p-g">
                      <h3 class="first">{{setLabel("contactPersonLabel")}}</h3>
                      <div class="p-g-12">
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon"><i class="fa fa-location-arrow"
                              aria-hidden="true"></i></span>
                          <input maxlength="100" type="text" autocomplete="off" pInputText
                            [placeholder]='setLabel("namePlaceholderLabel")' name="companyContactPersonName"
                            [(ngModel)]="package.companyContactPerson.name">
                        </div>
                      </div>
                      <div class="p-g-12">
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                          <input type="email" autocomplete="off" pInputText
                            [placeholder]='setLabel("emailPlaceholderLabel")' name="email"
                            [(ngModel)]="package.companyContactPerson.email">
                        </div>
                      </div>
                      <div class="p-g-12">
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                          <input maxlength="11" type="text" autocomplete="off" pInputText
                            [placeholder]='setLabel("contactNoPlaceholderLabel")' name="contactNo"
                            [(ngModel)]="package.companyContactPerson.contactNo">
                        </div>
                      </div>
                      <div class="p-g-12">
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon"><i class="fa fa-map-marker" aria-hidden="true"></i></span>
                          <input maxlength="11" type="text" autocomplete="off" pInputText
                            [placeholder]='setLabel("officeContactNoPlaceholderLabel")' name="officeContactNo"
                            [(ngModel)]="package.companyContactPerson.officeContactNo">
                        </div>
                      </div>
                      <div class="p-g-12">
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon"><i class="fa fa-address-book-o"
                              aria-hidden="true"></i></span>
                          <input type="text" autocomplete="off" pInputText
                            [placeholder]='setLabel("officeAddressPlaceholderLabel")' name="officeAddress"
                            [(ngModel)]="package.companyContactPerson.officeAddress">
                        </div>
                      </div>
                      <!-- <div class="p-g-12">
                                <div class="p-inputgroup">
                                  <span class="p-inputgroup-addon"><i class="fa fa-address-book-o" aria-hidden="true"></i></span>
                                  <input type="text" autocomplete="off" pInputText placeholder="Zip-Code" name="zipCode"
                                    [(ngModel)]="package.companyContactPerson.companyCard">
                                </div>
                              </div> -->
                    </div>
                  </div>

                </div>
              </div>

              <div class="nextBtn p-g-12">
                <!-- <button id="loginbtn" [disabled]="loading" (click)="reverse()"
                          class="p-button p-widget p-state-default p-corner-all">
                          <span class="p-button-text p-c">back</span>
                          <span *ngIf="loading" class="p-button-icon-left p-c fa fa-spinner fa-spin" style="font-size:24px"></span>
                        </button>&nbsp;&nbsp; -->
                <button id="loginbtn" (click)="update(memberSignUpForm)"
                  class="p-button p-widget p-state-default p-corner-all">
                  <span class="p-button-text p-c">{{setLabel("updateLabel")}}</span>
                  <span *ngIf="loading" class="p-button-icon-left p-c fa fa-spinner fa-spin"
                    style="font-size:24px"></span>
                </button>
              </div>
            </form>
          </div>
          <div style="clear: both;"></div>
        </div>
      </p-tabPanel>
      <p-tabPanel [header]='setLabel("accessControlHeaderLabel")'>
        <div class="card card-w-title">
          <div class="p-g-12">
            <div class="actMainHeading">
              <h3 class="main-heading first">{{setLabel("ACTLabel")}}</h3>
              <button (click)="updateAccessControl()"
                class="p-button p-widget p-state-default p-corner-all">{{setLabel("updateLabel")}}</button>
            </div>
            <div class="zoneMainStyle">
              <label for="zone-{{ i }}" *ngFor="let zone of zones; let i = index" class="zoneItemStyle"
                [ngClass]="{'selectedZone': zone.IsSelect == 1}">
                <span>{{ zone.ZoneName }}</span>
                <input [attr.id]="'zone-' + i" type="checkbox" [ngModel]="zone.IsSelect == 1 ? true: false"
                  (ngModelChange)="updateZoneSelection($event, zone.IsSelect, i)" />
              </label>
            </div>
          </div>
          <div style="clear: both;"></div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>